import request from '@/utils/request';
import { Announcement, rpAnnouncement, rpAnnouncementList, rpPaymentMethodList } from './type';
import { ResponseCommon } from '../chats/type';
import { AxiosResponse } from 'axios';

export interface PaymentMethod {
  id?: number;
  name: string;
  type: 'USDT' | 'TRX' | 'ETH' | 'BTC';
  contract_address: string;
  wallet_address: string;
  enabled: boolean;
}
export interface ConfigChains {
  contract_address_eth: string;
  wallet_address_eth: string;
  contract_address_tron: string;
  wallet_address_tron: string;
}
export interface RpPaymentMethod {
  code: string;
  data: {
    id?: number;
    name: string;
    type: 'USDT' | 'TRX' | 'ETH' | 'BTC';
    contract_address: string;
    wallet_address: string;
    enabled: boolean;
  }[];
  message?: string;
  [property: string]: any;
}

export interface RpSiteConfig {
  code: number;
  data: SiteConfig;
  message?: string;
  [property: string]: any;
}

// 添加类型定义
export interface SiteConfig {
  id?: number;
  site_name: string;
  site_desc: string;
  contact_email: string;
  telegram_link: string;
  created_at?: string;
  updated_at?: string;
  min_amount?: number;
  reason?: string;
}
// 获取公告列表
export function getAnnouncementList(): Promise<rpAnnouncementList> {
  return request({
    url: '/api/announcements',
    method: 'get'
  });
}

//获取指定位置的公告
export function getAnnouncementByPosition(position: string): Promise<rpAnnouncement> {
  return request({
    url: `/api/announcements/position/${position}`,
    method: 'get'
  });
}

// 创建公告
export function createAnnouncement(data: Announcement): Promise<ResponseCommon> {
  return request({
    url: '/api/announcements',
    method: 'post',
    data
  });
}

// 更新公告
export function updateAnnouncement(data: Announcement): Promise<ResponseCommon> {
  return request({
    url: `/api/announcements/${data.id}`,
    method: 'put',
    data
  });
}

// 获取所有支付方式
export function getPaymentMethodList(): Promise<rpPaymentMethodList> {
  return request({
    url: '/api/payment-methods',
    method: 'get'
  });
}

// 获取启用的支付方式
export function getEnabledPaymentMethods(): Promise<RpPaymentMethod> {
  return request({
    url: '/api/payment-methods/enabled',
    method: 'get'
  });
}

// 创建支付方式
export function createPaymentMethod(data: Omit<PaymentMethod, 'id'>): Promise<PaymentMethod> {
  return request({
    url: '/api/payment-methods',
    method: 'post',
    data
  });
}

// 更新支付方式
export function updatePaymentMethod(
  id: number,
  data: Partial<PaymentMethod>
): Promise<PaymentMethod> {
  return request({
    url: `/api/payment-methods/${id}`,
    method: 'put',
    data
  });
}

// 批量更新支付方式
export function batchUpdatePaymentMethods(data: {
  methods: PaymentMethod[];
}): Promise<PaymentMethod[]> {
  return request({
    url: '/api/payment-methods',
    method: 'post',
    data
  });
}

// 删除支付方式
export function deletePaymentMethod(id: number): Promise<null> {
  return request({
    url: `/api/payment-methods/${id}`,
    method: 'delete'
  });
}
// 获取网站配置
export function getSiteConfig(): Promise<RpSiteConfig> {
  return request({
    url: '/api/site-config',
    method: 'get'
  });
}

// 更新网站配置
export function updateSiteConfig(data: SiteConfig): Promise<SiteConfig> {
  return request({
    url: '/api/site-config',
    method: 'put',
    data
  });
}
